interface ProgressBarProps {
  current: number
  total: number
}

function ProgressBar({ current, total }: ProgressBarProps) {
  const percent = Math.min(100, Math.round((current / total) * 100))

  return (
    <div className="w-full">
      <div className="flex items-baseline justify-between mb-3">
        <span className="font-mono text-xs uppercase tracking-widest text-[#0A0A0A]/60">
          Progress
        </span>
        <span className="font-mono text-sm tabular-nums text-[#0A0A0A]">
          <span className="text-[#0F766E] font-semibold">{String(current).padStart(2, '0')}</span>
          <span className="text-[#0A0A0A]/30 mx-1">/</span>
          <span>{String(total).padStart(2, '0')}</span>
        </span>
      </div>
      <div className="h-1.5 w-full bg-[#E5E5E5] rounded-full overflow-hidden relative">
        <div
          role="progressbar"
          aria-valuenow={percent}
          aria-valuemin={0}
          aria-valuemax={100}
          className="h-full bg-gradient-to-r from-[#0F766E] to-[#0B524C] rounded-full transition-all duration-500 ease-out"
          style={{ width: `${percent}%` }}
        />
      </div>
    </div>
  )
}

export default ProgressBar
